import { getGeoArrayFromObject } from 'components/utils/geoSuggest/getGeoArrayFromObject';
import type { IOpeningHoursOverride, IRegularPeriod } from '@pepperhq/types-sdk';
import { LocationGeneralFormData } from './forms/LocationGeneralForm';
import { LocationAddressFormData } from './forms/LocationAddressForm';
import { LocationServicesFormData } from './forms/LocationServicesForm';
import { LocationLinksFormData } from './forms/LocationLinksForm';
import { LocationImagesFormData } from './forms/LocationImagesForm';
import { isDefined, isEmptyString } from 'lib/typeguards';

export function buildCreateLocationBody(
    general: LocationGeneralFormData,
    address: LocationAddressFormData,
    services: LocationServicesFormData,
    links: LocationLinksFormData,
    images: LocationImagesFormData
) {
    return {
        title: general.title,
        description: general.description,
        VATnumber: general.VATnumber,
        state: general.state,
        timezone: general.timezone,
        address: {
            address: address.address,
            country: address.country,
            fullAddress: address.fullAddress,
            googleMapsShortUrl: address.googleMapsShortUrl,
            postcode: address.postcode,
            summary: address.summary,
            town: address.town
        },
        // all days are closed by default
        openingHours: {
            regular: [] as IRegularPeriod[],
            overrides: [] as IOpeningHoursOverride<string>[]
        },
        services: {
            book_room: services.book_room,
            book_table: services.book_table,
            checkins: services.checkins,
            offline_checkin: services.offline_checkin,
            pre_order: services.pre_order,
            tab: services.tab,
            order_to_table: services.order_to_table,
            order_to_table_nfc: services.order_to_table_nfc,
            pay_at_table: services.pay_at_table,
            pay_at_table_nfc: services.pay_at_table_nfc,
            dine_in: services.dine_in,
            delivery: services.delivery
        },
        geo: getGeoArrayFromObject(address.geo),
        contacts: {
            email: general.email,
            phone: general.phone
        },
        links: {
            facebook: {
                enabled: isDefined(links.facebook) && !isEmptyString(links.facebook),
                parameters: links.facebook
            },
            twitter: {
                enabled: isDefined(links.twitter) && !isEmptyString(links.twitter),
                parameters: links.twitter
            },
            instagram: {
                enabled: isDefined(links.instagram) && !isEmptyString(links.instagram),
                parameters: links.instagram
            },
            citymapper: { enabled: links.citymapper },
            foursquare: { enabled: false },
            hailo: { enabled: false },
            uber: { enabled: links.uber }
        },
        mainImageUrl: images.mainImageUrl,
        listingImageUrl: images.listingImageUrl
    };
}
